<template>
    <ies-form-field :field="field">
        <input :name="this.field.fieldName" type="password" v-model="input" v-on:keyup="updateField()"
               :required="this.field.required"
               :disabled="this.field.disabled"
               :minlength="7" :maxlength="15">
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-text',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            input: this.field.value
        }
    },
    methods: {
    updateField: function(){
        this.field.value = this.input
    }

    }
}
</script>


